import { useContext } from 'react';

import { TimeseriesTickAxisContext } from '../context/TimeseriesTickAxis.context.js';

export const useTimeseriesTickAxis = () =>
  useContext(TimeseriesTickAxisContext);
